<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>设置邮费模板</span>
				<el-button class="button" @click="AddTemplate" type="success">添加模板</el-button>
			</div>
		</template>
		<div class="col">
			<el-table :data="list" border style="width: 100%" :header-cell-style="{'text-align':'center'}"
				:cell-style="{'text-align':'center'}">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="template_postage" label="模板名称">
					<template #default="scope">
						<!-- <a style="color: red;text-decoration: none;"
							:href="'#/main/productSetDeliveryExpressTemplate?pst_id='+scope.row.template_postage" target="_blank"
							class="buttonText">{{scope.row.template_postage}}</a> -->
						<p style="cursor: pointer;color: red;" @click="handleInfo(scope.row)">
							{{scope.row.template_postage}}
						</p>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="添加时间"></el-table-column>
				<el-table-column fixed="right" label="操作" width="150">
					<template #default="scope">
						<el-button @click="ModifyTemplatePostage(scope.row)" type="primary" size="medium">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules">
			<el-form-item>
				<el-form-item label="模板名称" prop="template_postage">
					<el-input placeholder="请填写模板名称" v-model="item.template_postage" size="small"></el-input>
				</el-form-item>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
	export default {
		data() {
			return {
				title: '新增模板',
				dialogFormVisible: false,
				list: [],
				postage_template: [],
				item: {
					template_postage: '',
				},
				rules: {
					template_postage: [{
						required: true,
						message: '请填写模板名称',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			AddTemplate() {
				this.resetObj(this.item)
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})

			},
			ModifyTemplatePostage(val) {
				let temp = this.cloneObj(val);
				this.title = '编辑';
				this.item = temp;
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			showTemplatePostage() {
				this.postage_template = [];
				this.httpPost({
					url: '/admin/product/productSetOmShippingList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					this.list = re.data;
					for (let i in re.data) {
						this.postage_template.push(re.data[i].template_postage);
					}
				})
			},
			handleInfo(val) {
				this.$router.push({
					path: '/main/productSetDeliveryExpressTemplate',
					query: {
						pst_id: val.id,
					}
				})
			},
			submit() {
				// console.log(this.item);
				// console.log(this.postage_template)
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						if (this.postage_template.indexOf(this.item.template_postage) != '-1') {
							this.$message.error('邮费模板已存在');
							return false;
						}
						this.httpPost({
							url: '/admin/product/productSetOmShippingUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.showTemplatePostage();
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			}
		},
		created() {
			this.fullscreenLoading = true;
			this.showTemplatePostage();
		}
	}
</script>